module.exports = __webpack_public_path__ + "img/space-introduce-3-en.11c5eaed.svg";